import * as React from "react"
import { StyleSheet, View, Text, FlatList, ListRenderItem, TouchableOpacity } from "react-native"

import { useEffect } from "react"
import { isEqualTrackRef, isTrackReference, isWeb, log, MessageDecoder,
    MessageEncoder,
    TrackReferenceOrPlaceholder,
    WidgetState, } from '@livekit/components-core';
import { CarouselLayout, Chat, ConnectionStateToast, FocusLayout, FocusLayoutContainer, GridLayout, LayoutContextProvider, MessageFormatter, ParticipantTile, RoomAudioRenderer, useCreateLayoutContext, usePinnedTracks, useTracks } from '@livekit/components-react';
import {
    RoomEvent,
    Track,
    // AudioSession,
    // LiveKitRoom,
    // useTracks,
    VideoTrack,
    // isTrackReference,
    // registerGlobals,
    // useLocalParticipant
} from "livekit-client"
import { dimensions } from "@Constants/baseStyles"

import { LiveKitRoom, useRoom, useLocalParticipant } from '@livekit/components-react';

import Feather from "@expo/vector-icons/Feather"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"

import AntDesign from "@expo/vector-icons/AntDesign"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import '@livekit/components-styles';

// This sample hardcodes a token which expires in 2 hours.
const wsURL = "wss://visioconference.ivehte.fr/"

export default function VideoCallScreen({
    token,
    setIsAudioEnabled,
    setIsCameraEnabled,
    isAudioEnabled,
    isCameraEnabled,
    isScreenShareEnabled,
    handleLeaveRoom
}) {
    console.log('=============== isAudioEnabled =====================', isAudioEnabled);
    console.log();
    console.log('================== isCameraEnabled ==================', isCameraEnabled);
    
    return (
        <LiveKitRoom
            data-lk-theme="default"
            serverUrl={wsURL}
            token={token}
            connect={true}
            options={{
                adaptiveStream: { pixelDensity: "screen" },
                videoCaptureDefaults: {
                    resolution: {
                        width: 640,
                        height: 480,
                    },
                    frameRate: 30,
                }
            }}
            audio={isAudioEnabled}
            video={isCameraEnabled}
            screen={false}
        >
            <RoomView
                setIsAudioEnabled={setIsAudioEnabled}
                setIsCameraEnabled={setIsCameraEnabled}
                isAudioEnabled={isAudioEnabled}
                isCameraEnabled={isCameraEnabled}
                handleLeaveRoom={handleLeaveRoom}
                // setLocalParticipant={setLocalParticipant}
            />
        </LiveKitRoom>
    )
}

const RoomView = ({ handleLeaveRoom, setIsAudioEnabled, setIsCameraEnabled, isCameraEnabled, isAudioEnabled }) => {

    // const [widgetState, setWidgetState] = React.useState<WidgetState>({
    //       showChat: false,
    //       unreadMessages: 0,
    //       showSettings: false,
    //     });

    // const room = useRoom(); // Accès à la salle
  const { localParticipant } = useLocalParticipant();

  localParticipant.on("trackSubscribed", (track) => {
    if (track.kind === "video") {
      console.log("Caméra activée");
    }
  });
  
  localParticipant.on("trackUnsubscribed", (track) => {
    if (track.kind === "video") {
      console.log("Caméra désactivée");
    }
  });

  const toggleCamera = async () => {
    if (localParticipant) {
      const isEnabled = localParticipant.isCameraEnabled;
      await localParticipant.setCameraEnabled(!isEnabled);
      setIsCameraEnabled(!isEnabled);
    }
  };

  const toggleMicrophone = async () => {
    if (localParticipant) {
        await localParticipant?.setMicrophoneEnabled(!isAudioEnabled)
        setIsAudioEnabled(!isAudioEnabled)
    }
   
}
    const lastAutoFocusedScreenShareTrack = React.useRef<TrackReferenceOrPlaceholder | null>(null);

    const tracks = useTracks(
          [
            { source: Track.Source.Camera, withPlaceholder: true },
            { source: Track.Source.ScreenShare, withPlaceholder: true },
          ],
          { updateOnlyOn: [RoomEvent.ActiveSpeakersChanged], onlySubscribed: false },
    );

    const layoutContext = useCreateLayoutContext();

    const widgetUpdate = (state: WidgetState) => {
          log.debug('updating widget state', state);
        //   setWidgetState(state);
        };
      
    const screenShareTracks = tracks
        ?.filter(isTrackReference)
        .filter((track) => track.publication.source === Track.Source.ScreenShare) ?? [];
    
    const focusTrack = usePinnedTracks(layoutContext)?.[0];
    const carouselTracks = tracks?.filter((track) => {
        if (!isTrackReference(track)) return false;

        // Ne garde pas le focus
        if (isEqualTrackRef(track, focusTrack)) return false;

        // Si c'est un partage d'écran de moi-même → on ne garde pas
        if (
            track.publication.source === Track.Source.ScreenShare &&
            track.participant.identity === localParticipant.identity
        ) {
            return false;
        }

        return true;
    }) ?? [];

    return (
        <div className="lk-video-conference" style={{ height: '80%' }}>
       
                <LayoutContextProvider
                value={layoutContext}
                // onPinChange={handleFocusStateChange}
                onWidgetChange={widgetUpdate}
                >
                <div className="lk-video-conference-inner">
                    {!focusTrack ? (
                    <div className="lk-grid-layout-wrapper">
                        <GridLayout tracks={tracks.filter(({ publication }) => publication)}>
                        <ParticipantTile />
                        </GridLayout>
                    </div>
                    ) : (
                    <div className="lk-focus-layout-wrapper">
                        <FocusLayoutContainer>
                        <CarouselLayout tracks={carouselTracks}>
                            <ParticipantTile />
                        </CarouselLayout>
                        {focusTrack && <FocusLayout trackRef={focusTrack} />}
                        </FocusLayoutContainer>
                    </div>
                    )}
                    {/* <ControlBarRoom controls={{ record: recordRoom, chat: true, leave: false, settings: !!SettingsComponent  }} variation="minimal" /> */}
                </div>
                {/* <Chat
                    style={{ display: widgetState.showChat ? 'grid' : 'none' }}
                    messageFormatter={chatMessageFormatter}
                    messageEncoder={chatMessageEncoder}
                    messageDecoder={chatMessageDecoder}
                /> */}
                {/* <Notes visioId={visioId} /> */}
                {/* {SettingsComponent && (
                    <div
                    className="lk-settings-menu-modal"
                    style={{ display: widgetState.showSettings ? 'block' : 'none' }}
                    >
                    <SettingsComponent />
                    </div>
                )} */}
               {/* <RoomAudioRenderer /> */}
                </LayoutContextProvider>
            
            
            {/* <ConnectionStateToast /> */}
            <View
                        style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            // paddingVertical: 20,
                            // paddingHorizontal: 40,
                            position: "absolute",
                            bottom: -60,
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20
                        }}
                    >
                        <TouchableOpacity onPress={toggleMicrophone}>
                            {!isAudioEnabled ? (
                                <Feather name="mic-off" size={24} color={baseColors.orange.primary} />
                            ) : (
                                <Feather name="mic" size={24} color={baseColors.green.primary} />
                            )}
                        </TouchableOpacity>

                        <TouchableOpacity onPress={toggleCamera}>
                            {!isCameraEnabled ? (
                                <Feather name="camera-off" size={24} color={baseColors.orange.primary} />
                            ) : (
                                <Feather name="camera" size={24} color={baseColors.green.primary} />
                            )}
                        </TouchableOpacity>

                        <TouchableOpacity onPress={handleLeaveRoom}>
                            <MaterialCommunityIcons name="logout" size={24} color={baseColors.orange.primary} />
                        </TouchableOpacity>
                    </View>
        </div>
    )
}

const styles = StyleSheet.create({
    screenShareContainer: {
        flex: 1,
    },
    screenShareView: {
        height: dimensions.fullHeight,
        width: dimensions.fullWidth,
    },
    participantView: {
        backgroundColor: '#2c2c2c',
        borderRadius: 8,
    },
    container: {
        flex: 1,
        width: '100%',
        height: '100%',
    }
})
